import React from 'react';
import Authentication from '../containers/Authentication';
import Footer from '../Footer';
import SideBar from '../SideBar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Layout(props) {
  let navBar;
  let footer;

  const adminDashboard = window.location.pathname === '/admin/dashboard';
  const hideSidebar = adminDashboard;
  if (
    window.location.pathname === '/signup' ||
    window.location.pathname === '/login' ||
    window.location.pathname === '/signupwizard' ||
    window.location.pathname === '/admin/dashboard' ||
    window.location.pathname === '/checkout' ||
    window.location.pathname === '/forgotpassword' ||
    window.location.pathname.includes('/updatepassword') ||
    window.location.pathname.includes('/published')
  ) {
    navBar = '';
    footer = '';
  } else if (
    window.location.pathname.includes('/main') ||
    window.location.pathname === '/account' ||
    window.location.pathname === '/dashboard' ||
    window.location.pathname === '/manager'
  ) {
    navBar = <Authentication />;
    footer = '';
  } else {
    navBar = <Authentication />;
    footer = <Footer />;
  }
  return (
    <>
      <Container fluid>
        {props.loggedIn ? (
          <Row
            className="logged-in-shell"
            style={{
              flexWrap: 'nowrap',
              marginLeft: '0',
              marginRight: '0',
              width: '100%',
            }}
          >
            {!hideSidebar && (
              <Col
                style={{
                  paddingLeft: '0',
                  paddingRight: '0',
                  flex: '0 0 220px',
                  maxWidth: '220px',
                }}
              >
                <SideBar props={props} />
              </Col>
            )}
            <Col
              className="logged-in-content"
              style={{
                padding: '0',
                flex: '1 1 auto',
                maxWidth: 'none',
                minWidth: '0',
              }}
            >
              {navBar}
              {props.children}
            </Col>
          </Row>
        ) : (
          <div>
            {navBar}
            {props.children}
            {footer}
          </div>
        )}
      </Container>
    </>
  );
}

export default Layout;
